import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, unref as _unref, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "chat-messages-panel" }
const _hoisted_2 = {
  key: 0,
  class: "chat-messages-panel__messages-reply"
}
const _hoisted_3 = { class: "chat-messages-panel__messages-reply-count" }
const _hoisted_4 = { class: "chat-messages-panel__messages-reply-btn" }
const _hoisted_5 = {
  key: 1,
  class: "chat-messages-panel__pagination-loader chat-messages-panel__pagination-loader--top"
}
const _hoisted_6 = {
  key: 2,
  class: "chat-messages-panel__pagination-loader chat-messages-panel__pagination-loader--bottom"
}
const _hoisted_7 = { class: "chat-messages-panel__input" }
const _hoisted_8 = {
  key: 0,
  class: "chat-messages-panel__input-answered-message"
}
const _hoisted_9 = { class: "answered-message__body" }
const _hoisted_10 = { class: "answered-message__body-header" }
const _hoisted_11 = { class: "answered-message__body-header-name" }
const _hoisted_12 = { class: "answered-message__body-header-date" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = {
  key: 1,
  class: "chat-messages-panel__input-answered-message"
}
const _hoisted_15 = { class: "answered-message__body" }
const _hoisted_16 = { class: "answered-message__body-header" }
const _hoisted_17 = { class: "answered-message__body-text" }
const _hoisted_18 = { class: "chat-messages-panel__input-field" }

import {
	computed,
	nextTick,
	onBeforeUnmount,
	onMounted,
	ref,
	watch
} from "vue";
import {useRoute, useRouter} from "vue-router";
import {
	ChatMessage,
	ChatModes,
	chatsStore
} from "@/store/chats";
import {workerStore} from "@/store/worker";
import moment from "moment/moment";
import AppLoader from "@/components/common/AppLoader.vue";
import ChatMessageComponent from "./ChatMessage.vue";
import AppCustomTextarea from "@/components/ui-kit/textarea/AppCustomTextarea.vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import {ChatsApi} from "@/ api/ChatsApi";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";
import ChatResendModal from "@/components/main/chat-panel/modals/ChatResendModal.vue";
import {declOfNum} from "@/utils/textHelpers";
import {useChatInputFocus} from "@/composables/useChatInputFocus";
import {debounce} from "lodash";


export default /*@__PURE__*/_defineComponent({
  __name: 'ChatMessagesPanel',
  props: {
    mode: {}
  },
  emits: ["on-open-message"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const sendMessageTypes = [
	{
		id: 0,
		sendMessageText: "Отправить (Ctrl+Enter)"
	},
	{
		id: 1,
		sendMessageText: "Отправить (Enter)"
	},
]

const chatStore = chatsStore()
const wStore = workerStore()
const route = useRoute()
const router = useRouter()
const props = __props
const emit = __emit

const $resendMessages = ref<typeof ChatResendModal | null>(null)
const { inputRef, focusSync, focusAsync } = useChatInputFocus()
const $messagesArea = ref<HTMLDivElement | null>(null)
const message = ref<string>("")
const selectedMessages = ref<number[]>([])
const isScrollBtnVisible = ref(false)
const isFirstLoading = ref(true)
const isFirstLoadingFromSearch = ref(true)
const currentChatScrollTopPosition = ref<number | null>(null)

const worker = computed(() => wStore.workerProfile)
const isActiveMode = computed(() => props.mode === 'chat')
const chat = computed(() => chatStore.getOpenedChat)
const chatLoadingState = computed(() => chatStore.getOpenedChatLoadState)
const isLoadingChat = computed(() => chatStore.isChatMessagesLoading)
const isLoadingPrev = computed(() => chatStore.loadingPrev)
const isLoadingNext = computed(() => chatStore.loadingNext)
const chatMessages = computed(() =>
	props.mode === 'chat'
		? chatStore.getOpenedChatMessages
		: chatStore.getSearchedMessages
)
const chatMessagesHistory = computed(() => chatStore.getOpenedChatsHistory)
const resendMessagesList = computed(() => chatStore.resendMessages)
const workerSendMessageType = computed(() => {
	if (!worker.value) return sendMessageTypes[0]

	return sendMessageTypes.find(type => type.id === worker.value?.MessageSendingWay)
})

const attachOrResendMessages = computed(() =>
	resendMessagesList.value && resendMessagesList.value.chatId === chat.value?.Id
		? resendMessagesList.value.messages
		: null
)

const canSendMessage = computed(() =>
	!!chat.value?.Id && (message.value.trim().length > 0 || !!attachOrResendMessages.value?.length)
)

const toggleMessage = (message: ChatMessage, event?: MouseEvent) => {
	if ((event?.target as HTMLElement)?.closest('.link-message')) {
		return
	}
	if (props.mode === 'search-messages') {
		emit('on-open-message', message)
		return
	}

	if (selectedMessages.value.includes(message.Id)) {
		selectedMessages.value.splice(selectedMessages.value.indexOf(message.Id), 1)
	} else {
		selectedMessages.value.push(message.Id)
	}
}

const readMessage = (message: ChatMessage) => {
	if (message.Unreaded && worker.value?.Id !== message.WorkerId) {
		chatStore.readChatMessage(message.Id)
	}
}

const setMessageAnswered = (messageId: number) => {
	chatStore.setResendMessages({
		chatId: chat.value?.Id as number,
		messages: [chatMessages.value.find(message => message.Id === messageId)!]
	})
	focusAsync()
}

const onDropSelected = () => selectedMessages.value = []

const getDialogDate = (date: string) => moment(date).format("DD.MM.YYYY HH:mm");

const scrollToBottom = () => {
	const el = $messagesArea.value
	if (el) {
		el.scrollTop = el.scrollHeight
	}
}

const scrollDown = () => nextTick(scrollToBottom)

const scrollToPosition = (position: number) => nextTick(
	() => {
		$messagesArea.value ? $messagesArea.value.scrollTop = position : null
	}
)

const sendMessage = async () => {
	if (canSendMessage.value) {
		try {
			const messageText = message.value
			const attaches = JSON.parse(JSON.stringify(attachOrResendMessages.value))
			message.value = ''
			chatStore.setResendMessages(null)
			const lastMessageId = chatMessages.value[chatMessages.value.length - 1]?.Id
			await chatStore.createMessage({
				chatId: chat.value?.Id,
				text: messageText.replace(/\n{3,}/g, '\n\n'),
				attachedMessageIds: attaches
					? attaches.map(message => message.Id)
					: undefined,
			}, getMessageDate(), lastMessageId)
		} catch (e) {
			console.log(e)
		}
	}
}

const resendMessages = async () => {
	$resendMessages.value?.onOpen(chatMessages.value.filter(message => selectedMessages.value.includes(message.Id)))
}

const getMessageDate = () => {
	const date = new Date();

	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const day = String(date.getDate()).padStart(2, '0');

	const hours = String(date.getHours()).padStart(2, '0');
	const minutes = String(date.getMinutes()).padStart(2, '0');
	const seconds = String(date.getSeconds()).padStart(2, '0');
	const milliseconds = String(date.getMilliseconds()).padStart(3, '0');

	return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}Z`;
}

const isAdjustingScroll = ref(false)
const paginationCooldownUntil = ref(0)

const preservePrependAnchor = async (action: () => Promise<void>) => {
	const el = $messagesArea.value
	if (!el) {
		await action();
		return
	}

	const prevHeight = el.scrollHeight
	const prevTop = el.scrollTop
	await action()
	await nextTick()
	await new Promise<void>(resolve => requestAnimationFrame(() => resolve()))
	if ($messagesArea.value) {
		isAdjustingScroll.value = true
		const newTop = prevTop + ($messagesArea.value.scrollHeight - prevHeight)
		$messagesArea.value.scrollTop = newTop
		currentChatScrollTopPosition.value = newTop
		requestAnimationFrame(() => { isAdjustingScroll.value = false })
	}
}

const loadPrev = async () => {
	if (!chat.value || !chatMessages.value.length) return

	if (chatStore.loadingPrev || chatStore.loadingNext) return

	if (!chatLoadingState.value?.canLoadPrev) return

	const chatId = chat.value.Id
	const date = chatMessages.value[0].Date
	await preservePrependAnchor(() => chatStore.getPrevMessages(chatId, date))
	paginationCooldownUntil.value = Date.now() + 250
}

const loadNext = async () => {
	if (!chat.value || !chatMessages.value.length) return

	if (chatStore.loadingPrev || chatStore.loadingNext) return

	if (!chatLoadingState.value?.canLoadNext) return

	await chatStore.getNextMessages(chat.value.Id, chatMessages.value[chatMessages.value.length - 1].Date)
	paginationCooldownUntil.value = Date.now() + 250
}

const loadPrevThrottled = debounce(loadPrev, 200, { leading: false, trailing: true })
const loadNextThrottled = debounce(loadNext, 200, { leading: false, trailing: true })

const updateChatMessages = () => {
	const el = $messagesArea.value
	if (!el || isAdjustingScroll.value || Date.now() < paginationCooldownUntil.value) return

	const scrollTop = el.scrollTop
	const prev = currentChatScrollTopPosition.value

	if (prev !== null && scrollTop < 500 && scrollTop < prev) {
		loadNextThrottled.cancel()
		loadPrevThrottled()
	} else if (prev !== null && scrollTop + el.offsetHeight + 500 > el.scrollHeight && scrollTop > prev) {
		loadPrevThrottled.cancel()
		loadNextThrottled()
	}

	currentChatScrollTopPosition.value = scrollTop
}

const setChatPosition = (scrollTop?: number) => {
	if (props.mode === 'chat') {
		if (scrollTop) {
			scrollToPosition(scrollTop)
		} else {
			const history = chatMessagesHistory.value.find(c => c.Id === chat.value?.Id)
			if (typeof history?.ScrollTop === 'number') {
				scrollToPosition(history.ScrollTop)
			} else {
				scrollDown()
			}
		}
	}
}

watch(chatMessages, () => {
	if (isFirstLoading.value && chatMessages.value.length) {
		if (!route.query.message) {
			setChatPosition()
		}

		isFirstLoading.value = false
	}
});

// Переменные чисто для отработки вотчеров
let prevChatId: number | null = null
let prevMessagesLen = 0
let prevLastMessageId: number | null = null

watch(chatMessages, (newMessages) => {
	const last = newMessages[newMessages.length - 1] ?? null
	const chatId = chatStore.getOpenedChatId

	const isAppend =
		isActiveMode.value &&
		chatId === prevChatId &&
		prevMessagesLen > 0 &&
		newMessages.length > prevMessagesLen &&
		last?.Id !== prevLastMessageId

	prevChatId = chatId
	prevMessagesLen = newMessages.length
	prevLastMessageId = last?.Id ?? null

	if (!isAppend) {
		return
	}

	if (worker.value?.Id === last?.WorkerId || !isScrollBtnVisible.value) {
		scrollToBottom()
	}
}, { flush: 'post' });

watch(() => chatStore.getOpenedChatId, (newId, oldId) => {
	if (!newId || newId === oldId || !isActiveMode.value) return
	if (!route.query.message) {
		setChatPosition()
	}

	focusAsync()
}, { flush: 'post' });

let scrollHandler: (() => void) | null = null

const centerOnTargetMessage = async () => {
	if (!route.query.message) return

	const targetId = parseInt(route.query.message as string)
	await nextTick()
	const tryScroll = (attempt = 0) => {
		const element = document.getElementById(`message-${targetId}`) as HTMLElement | null
		if (element) {
			element.scrollIntoView({ block: 'center', behavior: 'auto' })
			if ($messagesArea.value) currentChatScrollTopPosition.value = $messagesArea.value.scrollTop

			element.style.backgroundColor = '#D2D2D2'
			setTimeout(() => { element.style.backgroundColor = 'transparent' }, 1000)
			isFirstLoadingFromSearch.value = false
			return
		}
		if (attempt < 15) {
			requestAnimationFrame(() => tryScroll(attempt + 1))
		} else {
			isFirstLoadingFromSearch.value = false
		}
	}
	tryScroll()
}

watch(isLoadingChat, async (newVal) => {
	if (!newVal) {
		await nextTick()
		currentChatScrollTopPosition.value = $messagesArea.value?.scrollTop as number
		if (route.query.message) {
			await centerOnTargetMessage()
		}
	}
})

const loaderStyle = computed(() => ({
	'background-color': 'rgba(255, 255, 255, 1)'
}))

onMounted(async () => {
	if (!route.query.message) {
		isFirstLoadingFromSearch.value = false
	}
	if (!route.query.id) {
		chatStore.setMode('list')
		await router.push({
			path: '/',
			query: {
				...route.query,
				mode: 'list'
			}
		});
	} else {
		const routeChatId = parseInt(route.query.id as string)
		const routeMessageId = route.query.message ? parseInt(route.query.message as string) : null

		const restoredDialog = chatStore.dialogs.find(d => d.Id === routeChatId)
		chatStore.addOpenedChatsHistory({
			Id: routeChatId,
			Name: restoredDialog?.Name ?? '',
			ScrollTop: null
		})

		const alreadyOpened = chatStore.openedChat === routeChatId
		const alreadyLoaded = !!chatStore.chatsById[routeChatId]
		const alreadyLoading = !!chatStore.loadingByChatId[routeChatId]?.initial
		if (!alreadyOpened || (!routeMessageId && !alreadyLoaded && !alreadyLoading)) {
			chatStore.setOpenedChat(routeChatId, routeMessageId)
		}
		await nextTick()
		if ($messagesArea.value && !routeMessageId) {
			setChatPosition()
		}

		if (routeMessageId && alreadyLoaded && !alreadyLoading) {
			await centerOnTargetMessage()
		}
	}

	if (isActiveMode.value) {
		focusAsync()
	}

	await nextTick()

	prevChatId = chatStore.getOpenedChatId
	prevMessagesLen = chatMessages.value.length
	prevLastMessageId = chatMessages.value[chatMessages.value.length - 1]?.Id ?? null

	scrollHandler = () => {
		if (!$messagesArea.value) return
		isScrollBtnVisible.value =
			$messagesArea.value.scrollTop + $messagesArea.value.offsetHeight < ($messagesArea.value.scrollHeight - 50)

		updateChatMessages()

		if (chat.value) {
			chatStore.saveChatScrollPosition(chat.value.Id, $messagesArea.value.scrollTop)
		}
	}
	$messagesArea.value?.addEventListener('scroll', scrollHandler)
})


onBeforeUnmount(() => {
	loadPrevThrottled.cancel()
	loadNextThrottled.cancel()
	if (scrollHandler && $messagesArea.value) {
		$messagesArea.value.removeEventListener('scroll', scrollHandler)
		scrollHandler = null
	}
	if (route.query.message) {
		const query = { ...route.query };
		delete query.message;
		router.replace({ query });
	}
});

__expose({ focusSync, focusAsync })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ChatResendModal, {
      ref_key: "$resendMessages",
      ref: $resendMessages,
      title: "Выберите чат для пересылки",
      onOnResend: _cache[0] || (_cache[0] = ($event: any) => (selectedMessages.value = []))
    }, null, 512),
    _createElementVNode("div", _hoisted_1, [
      (isLoadingChat.value || isFirstLoadingFromSearch.value)
        ? (_openBlock(), _createBlock(AppLoader, {
            key: 0,
            style: _normalizeStyle(loaderStyle.value)
          }, null, 8, ["style"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "chat-messages-panel__messages",
        ref_key: "$messagesArea",
        ref: $messagesArea
      }, [
        (selectedMessages.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createTextVNode(" Выбрано сообщений:  " + _toDisplayString(selectedMessages.value.length) + " ", 1),
                _createVNode(AppIcon, {
                  name: "close-bold",
                  width: "12px",
                  color: "#D2D2D2",
                  "hover-color": "#4D4D4D",
                  cursor: "pointer",
                  style: { marginTop: '-2px' },
                  onClick: _withModifiers(onDropSelected, ["stop"])
                })
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(AppIcon, {
                  class: "chat-messages-panel__messages-reply-btn-icon",
                  name: "reply-right",
                  width: "18px"
                }),
                _createElementVNode("span", {
                  class: "chat-messages-panel__messages-reply-btn-text",
                  onClick: resendMessages
                }, " Переслать ")
              ])
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chatMessages.value, (message) => {
          return (_openBlock(), _createBlock(ChatMessageComponent, {
            key: message.Id,
            message: message,
            selected: selectedMessages.value.includes(message.Id),
            mode: props.mode,
            onClick: ($event: any) => (toggleMessage(message, $event)),
            onMouseenter: ($event: any) => (readMessage(message)),
            onSetAnswered: setMessageAnswered
          }, null, 8, ["message", "selected", "mode", "onClick", "onMouseenter"]))
        }), 128))
      ], 512),
      (isLoadingPrev.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(AppLoader)
          ]))
        : _createCommentVNode("", true),
      (isLoadingNext.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(AppLoader)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        (isScrollBtnVisible.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "chat-messages-panel__scroll-btn",
              onClick: scrollDown
            }, [
              _createVNode(AppIcon, {
                name: "arrow-down",
                width: "24px",
                color: "#fff"
              })
            ]))
          : _createCommentVNode("", true),
        (attachOrResendMessages.value && props.mode === 'chat')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (attachOrResendMessages.value.length === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "answered-message__lable" }, null, -1)),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, _toDisplayString(attachOrResendMessages.value[0].WorkerName), 1),
                        _createElementVNode("div", _hoisted_12, _toDisplayString(getDialogDate(attachOrResendMessages.value[0].Date)), 1),
                        _createVNode(AppIcon, {
                          class: "answered-message__body-header-close",
                          name: "close-bold",
                          width: "12px",
                          color: "#D2D2D2",
                          "hover-color": "#4D4D4D",
                          cursor: "pointer",
                          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_unref(chatStore).setResendMessages(null)), ["stop"]))
                        })
                      ]),
                      _createElementVNode("div", {
                        class: "answered-message__body-text",
                        innerHTML: attachOrResendMessages.value[0].Text.replaceAll('\n', '<br>')
                      }, null, 8, _hoisted_13)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "answered-message__lable" }, null, -1)),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(AppIcon, {
                          class: "answered-message__body-header-close",
                          name: "close-bold",
                          width: "12px",
                          color: "#D2D2D2",
                          "hover-color": "#4D4D4D",
                          cursor: "pointer",
                          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_unref(chatStore).setResendMessages(null)), ["stop"]))
                        })
                      ]),
                      _createElementVNode("div", _hoisted_17, _toDisplayString(attachOrResendMessages.value?.length) + " " + _toDisplayString(_unref(declOfNum)(attachOrResendMessages.value?.length, ['сообщение', 'сообщения', 'сообщений'])), 1)
                    ])
                  ]))
            ], 64))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", _hoisted_18, [
          _createVNode(AppCustomTextarea, {
            ref_key: "inputRef",
            ref: inputRef,
            modelValue: message.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((message).value = $event)),
            placeholder: "Введите сообщение...",
            "min-height": 32,
            "max-height": 100,
            "new-line-mode": workerSendMessageType.value?.id === 0 ? 'enter' : 'shift-enter',
            onEnter: sendMessage,
            onCtrlEnter: sendMessage
          }, null, 8, ["modelValue", "new-line-mode"]),
          _createVNode(AppTooltip, {
            class: "chat-search-panel__edit-btn",
            text: workerSendMessageType.value.sendMessageText
          }, {
            activator: _withCtx(() => [
              _createVNode(AppIcon, {
                class: "chat-messages-panel__input-field-btn",
                name: "send-message",
                width: "16px",
                color: canSendMessage.value ? '#3F884F' : '#D2D2D2',
                "hover-color": "#3F884F",
                cursor: "pointer",
                onClick: sendMessage
              }, null, 8, ["color"])
            ]),
            _: 1
          }, 8, ["text"])
        ], 512), [
          [_vShow, props.mode === 'chat']
        ])
      ])
    ])
  ], 64))
}
}

})